import {PERMISSIONS} from 'rbac/config'

export interface SettingsNavPage {
  pathname: string
  labelKey: string
  permission: string
  /** Hidden from roles other than Administrator, on top of the permission. */
  adminOnly?: boolean
}

/** The Settings pages in navigation order, shared by desktop and phone. */
export const SETTINGS_NAV_PAGES: SettingsNavPage[] = [
  {
    pathname: '/settings/general',
    labelKey: 'NAV_GENERAL',
    permission: PERMISSIONS.GENERAL_SETTINGS.READ,
    adminOnly: true,
  },
  {
    pathname: '/settings/block-pages',
    labelKey: 'NAV_BLOCK_PAGES',
    permission: PERMISSIONS.BLOCK_PAGES.READ,
  },
  {
    pathname: '/settings/endpoints',
    labelKey: 'NAV_ENDPOINTS',
    permission: PERMISSIONS.ENDPOINT_CONFIGURATION.READ,
  },
  {
    pathname: '/settings/users',
    labelKey: 'NAV_USERS',
    permission: PERMISSIONS.USER_MANAGEMENT.READ,
  },
  {
    pathname: '/settings/audit-log',
    labelKey: 'NAV_AUDIT_LOG',
    permission: PERMISSIONS.AUDIT_LOG.READ,
  },
  {
    pathname: '/settings/siem',
    labelKey: 'NAV_SIEM',
    permission: PERMISSIONS.ADD_S3_BUCKET_LOCATION.READ,
  },
  {
    pathname: '/settings/api',
    labelKey: 'NAV_API',
    permission: PERMISSIONS.API_KEYS.READ,
  },
  {
    pathname: '/settings/billing',
    labelKey: 'NAV_SUBSCRIPTION',
    permission: PERMISSIONS.BILLING_DETAILS.READ,
    adminOnly: true,
  },
]
